export enum TICKET_HOLDER_FIELD {
    FirstName = "FirstName",
    LastName = "LastName",
    BirthDate = "BirthDate",
    Nationality = "Nationality",
    AddressDetails = "AddressDetails",
    EmailAddress = "EmailAddress",
    PhoneNumber = "PhoneNumber",
    CityOfBirth = "CityOfBirth",
    IdentificationNumber = "IdentificationNumber"
}

export const ticketHolderFieldOptions = [
    {label: 'First name', value: TICKET_HOLDER_FIELD.FirstName},
    {label: 'Last name', value: TICKET_HOLDER_FIELD.LastName},
    {label: 'Birth date', value: TICKET_HOLDER_FIELD.BirthDate},
    {label: 'Nationality', value: TICKET_HOLDER_FIELD.Nationality},
    {label: 'Address details', value: TICKET_HOLDER_FIELD.AddressDetails},
    {label: 'Email address', value: TICKET_HOLDER_FIELD.EmailAddress},
    {label: 'Phone number', value: TICKET_HOLDER_FIELD.PhoneNumber},
    {label: 'City of birth', value: TICKET_HOLDER_FIELD.CityOfBirth},
    {label: 'Identification number', value: TICKET_HOLDER_FIELD.IdentificationNumber}
];

// Pre-selected when "Require ticket holder information" is first enabled.
export const defaultTicketHolderFields: TICKET_HOLDER_FIELD[] = [
    TICKET_HOLDER_FIELD.FirstName,
    TICKET_HOLDER_FIELD.LastName,
    TICKET_HOLDER_FIELD.BirthDate,
    TICKET_HOLDER_FIELD.Nationality
];

// Always required whenever any ticket holder field is requested; cannot be deselected.
export const mandatoryTicketHolderFields: TICKET_HOLDER_FIELD[] = [
    TICKET_HOLDER_FIELD.FirstName,
    TICKET_HOLDER_FIELD.LastName
];
